import type { AppLocale } from "./index"
import { EXTENDED_AUTOCLAN_UI } from "./extendedLocaleUi"
import { isExtendedLocale } from "./isExtendedLocale"
import { autoclanUi as legacyAutoclanUi, type AutoclanUiKey } from "./legacy/autoclanUi"
import type { AppLocale as LegacyAppLocale } from "./legacy/index"
import { PUBLIC_EXTRA_AUTOCLAN_UI } from "./publicExtraAutoclanUi"
import { isPublicExtraLocale } from "./publicExtraSignals"
import { uzbekLatinToCyrillic } from "./uzbekCyrillic"
import { isExpansionLocale } from "./publicExpansionSignals"
import { EXPANSION_AUTOCLAN_UI } from "./publicExpansionAutoclanUi"

export type { AutoclanUiKey } from "./legacy/autoclanUi"

export function autoclanUi(
  locale: AppLocale,
  key: AutoclanUiKey,
  vars?: Record<string, string | number>,
): string {
  if (isExpansionLocale(locale)) {
    let value = EXPANSION_AUTOCLAN_UI[locale][key]
    if (vars) {
      for (const [name, replacement] of Object.entries(vars)) {
        value = value.split(`{${name}}`).join(String(replacement))
      }
    }
    return value
  }
  if (!isPublicExtraLocale(locale) && !isExtendedLocale(locale)) {
    const value = legacyAutoclanUi(locale as LegacyAppLocale, key, vars)
    return locale === "uz" ? uzbekLatinToCyrillic(value) : value
  }

  let value = isPublicExtraLocale(locale)
    ? PUBLIC_EXTRA_AUTOCLAN_UI[locale][key]
    : (EXTENDED_AUTOCLAN_UI[locale] as Record<AutoclanUiKey, string>)[key]

  if (vars) {
    for (const [name, replacement] of Object.entries(vars)) {
      value = value.split(`{${name}}`).join(String(replacement))
    }
  }
  return value
}
